import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-skill-xaxp",
  "use": "icon-skill-xaxp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-skill-xaxp\">\n\t<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\">\n\t\t<path d=\"M5.153 21.423c.657-1.894 2.731-3.292 5.05-3.395q.374-.017.8-.028l.795.048c2.341.142 4.397 1.49 5.05 3.375\" />\n\t\t<path d=\"M10 4h3m7 7v3M2 12v2M6 4a4 4 0 0 0-4 4m0 10.195A3.805 3.805 0 0 0 5.805 22h10.39A3.805 3.805 0 0 0 20 18.195M13.5 12.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m6-9.562V4.5m0 0v1.563m0-1.563h-1.25m1.25 0h1.25m1.25 0l-1.084-.361a1.67 1.67 0 0 1-1.055-1.055L19.5 2l-.361 1.084a1.67 1.67 0 0 1-1.055 1.055L17 4.5l1.084.361c.498.166.889.557 1.055 1.055L19.5 7l.361-1.084a1.67 1.67 0 0 1 1.055-1.055z\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/skill-xaxp.svg
// module id = gXnU
// module chunks = 10